import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import React from "react";
import { WIDGET_URL } from "../api";
import { XMarkIcon } from "@heroicons/react/20/solid";
import useLoadWidget from "../hooks/useLoadWidget";
import ReviseAnswerModal from "./ReviseAnswerModal";

const RenderWidget = ({ test }) => {
  const { onLoad, reviseAnswerData, showReviseModal, setShowReviseModal } =
    useLoadWidget({
      test,
    });

  return (
    <>
      <iframe
        className="w-full h-[100dvh]"
        id="support-magic-widget-iframe"
        src={`${WIDGET_URL}/chat.html`}
        title="Live Chat Widget"
        onLoad={onLoad}
      />

      <ReviseAnswerModal
        defaultValues={reviseAnswerData}
        open={showReviseModal}
        onClose={() => {
          setShowReviseModal(false);
        }}
      />
    </>
  );
};

export default function ChatWidgetModal({ open, onClose, test, disabled }) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-[999999]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/30 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-[999999] w-screen overflow-hidden">
        <div className="flex min-h-[100dvh] justify-center text-center">
          <DialogPanel
            transition
            className="flex flex-col transform overflow-hidden bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full h-[100dvh]"
          >
            <button type="button" onClick={onClose} className="pointer-events-auto">
              <XMarkIcon className="size-7 text-gray-500 hover:text-gray-900 fixed top-[max(1rem,env(safe-area-inset-top))] right-[max(1rem,env(safe-area-inset-right))]" />
            </button>

            {open && <RenderWidget test={test} disabled={disabled} />}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
